import { ProgramRecommenderStats, WorksiteData } from './types'

export const formatNumber = (num: number): string => {
  if (num === 0) return '0'

  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: 1,
    minimumFractionDigits: 0,
  }).format(num)
}

export const getReach = (type: string, stats: WorksiteData) => {
  try {
    return Math.round((stats[type] / stats.totalEmployees) * 100) || 0
  } catch (error) {
    return 0
  }
}

export const calculateYearlyCarbonImpact = (
  carbonImpact: {
    carImpact: number
    micromobilityImpact: number
    transitImpact: number
  },
  daysInOfficeInWeek: number
) => {
  const daysInYear = daysInOfficeInWeek * 4 * 12
  return {
    carImpact: carbonImpact.carImpact * daysInYear,
    micromobilityImpact: carbonImpact.micromobilityImpact * daysInYear,
    transitImpact: carbonImpact.transitImpact * daysInYear,
  }
}

// Sometimes the worksites id from the server does not come back without - (dash)
// because of camel case library
// so searching for worksiteId instead of object id
export const getStats = (
  selectedWorksite: string,
  programRecommenderData: ProgramRecommenderStats
) => {
  if (!selectedWorksite) {
    return programRecommenderData.allEmployeeStats
  }
  const data = Object.values(programRecommenderData.worksites).find(
    (worksite) => worksite.worksiteId === selectedWorksite
  )
  if (!data) {
    return programRecommenderData.allEmployeeStats
  }
  return data
}
